import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import BackButton from "../components/BackButton.js";
import "../css/WorkspaceTabs.css";

/**
 * Primary workspace tabs: Defects | Cost analysis | Risk analysis.
 */
const WorkspaceLayout = () => {
    return (
        <div className="workspace-shell">
            <nav className="workspace-primary-tabs" aria-label="Workspace">
                <BackButton className="workspace-back-to-map" />
                <div className="workspace-primary-tab-links">
                    <NavLink
                        to="/defects"
                        end
                        className={({ isActive }) =>
                            `workspace-tab ${isActive ? "workspace-tab-active" : ""}`
                        }
                    >
                        Defects
                    </NavLink>
                    <NavLink
                        to="/analytics/cost-analysis"
                        end
                        className={({ isActive }) =>
                            `workspace-tab ${isActive ? "workspace-tab-active" : ""}`
                        }
                    >
                        Cost analysis
                    </NavLink>
                    <NavLink
                        to="/analytics/risk-analysis"
                        end
                        className={({ isActive }) =>
                            `workspace-tab ${isActive ? "workspace-tab-active" : ""}`
                        }
                    >
                        Risk analysis
                    </NavLink>
                </div>
            </nav>
            <Outlet />
        </div>
    );
};

export default WorkspaceLayout;
